'use strict';

const firstCharToLowerCase = (value) => value[0].toLowerCase() + value.slice(1);
const isEmpty = (value) => {
    return value == null || value === '';
};
const pascalCase = (text) => {
    return text
        .split('-')
        .map((t) => t[0].toUpperCase() + t.slice(1))
        .join('');
};
const isAllCaps = /^[\dA-Z]+$/;
const kebabCase = (text) => isAllCaps.test(text)
    ? text
    : text.replace(/([A-Z])/, (match) => `-${match[0].toLowerCase()}`);

exports.firstCharToLowerCase = firstCharToLowerCase;
exports.isEmpty = isEmpty;
exports.kebabCase = kebabCase;
exports.pascalCase = pascalCase;
//# sourceMappingURL=string.js.map
